import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useLocation } from 'react-router-dom';
import { getProductButtonColor, getProductName } from '../../utilities/productColor';

function ExitTerms(props) {
    const { externalLink } = props;
    const location = useLocation();
    const productButtonColor = getProductButtonColor(location.pathname);
  const productName = getProductName(location.pathname).toLocaleLowerCase();

    return (
        <>
            {location.pathname.includes("steqeyma") || location.pathname.includes("stoboclo") || location.pathname.includes("osenvelt") || location.pathname.includes("avtozma") ? (<Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className={`popup ${productName}-modal-content`}
            >
                <Modal.Body className='popup-padding'>
                    <div style={{ textAlign: "center" }}>
                        <p className='heading'>You are now leaving
                        </p>
                        <h2>CelltrionCares.com</h2>
                        <p style={{ paddingTop: "20px" }} className='confirm-text'>Please click "OK" if you with to continue, or click "cancel."</p>
                    </div>
                </Modal.Body>
                <Modal.Footer className='popup-footer'>
                    <Button className='theme-btn left-btn' style={{backgroundColor: productButtonColor}} onClick={() => { window.open(externalLink, "_blank"); props.onHide() }}>OK</Button>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button className='theme-btn right-btn' onClick={props.onHide}>Cancel</Button>
                </Modal.Footer>
            </Modal>) : (
                <Modal
                    {...props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className='popup'
                >
                    <Modal.Body className='popup-padding'>
                        <div style={{ textAlign: "center" }}>
                            <h3>You are now leaving CelltrionCARES.com</h3>
                            <p style={{ paddingTop: "20px" }}>Please click "OK" if you with to continue, or click "Cancel."</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className='popup-footer'>
                        <Button className='theme-btn' onClick={() => { window.open(externalLink, "_blank"); props.onHide() }}>Ok</Button>&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button className='theme-btn' onClick={props.onHide}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}
export default ExitTerms

